import {
    GetSelectedDropdownValues,
    IFilter,
    InitializeFilterDropdown,
    InitializeFilterOptGroupDropdown,
    DropdownOptGroup,
} from "../../shared/scripts/dropdown-functions";

import { FileUpload } from "../list-management/scripts/special-case-sections/FileUpload";
import { ListSelection } from "../list-management/scripts/special-case-sections/ListSelection";


export class AnimalModelsFormPage {
    private $center!: JQuery<HTMLSelectElement>;
    private $cores!: JQuery<HTMLSelectElement>;
    private $projects!: JQuery<HTMLSelectElement>;
    private $virusFamily!: JQuery<HTMLSelectElement>;
    private $challenge!: JQuery<HTMLSelectElement>;
   

    private coreOpts: HTMLOptionElement[] = [];
    private projectOpts: HTMLOptionElement[] = [];
    private challengeOpts: HTMLOptionElement[] = [];

    private hasTriedSubmit = false;
    private protocolUpload!: FileUpload;
    private pmids!: ListSelection;

    constructor(
        private maps: {
            coreByCenter: Record<number, number[]>;
            projectByCenter: Record<number, number[]>;
            virusByFamily: Record<number, number[]>;
            
        }
    ) {
        // Handles
        this.$center = $("#Input_CenterId") as unknown as JQuery<HTMLSelectElement>;
        this.$cores = $("#Input_CoreIds") as unknown as JQuery<HTMLSelectElement>;
        this.$projects = $("#Input_ProjectIds") as unknown as JQuery<HTMLSelectElement>;
        this.$virusFamily = $("#Input_VirusFamilyId") as unknown as JQuery<HTMLSelectElement>;
        this.$challenge = $("#Input_ChallengeVirusIds") as unknown as JQuery<HTMLSelectElement>;

        // Cache original options for dynamic rebuilds
        this.coreOpts = this.readOptions(this.$cores);
        this.projectOpts = this.readOptions(this.$projects);
        this.challengeOpts = this.readOptions(this.$challenge);
        console.groupCollapsed("[AM Form] bootstrap");
        console.log("[maps]", this.maps);
        console.log("[coreOpts]", this.coreOpts.map(o => o.value));
        console.log("[projectOpts]", this.projectOpts.map(o => o.value));
        console.groupEnd();
        // Driving singles
        InitializeFilterDropdown(
            "#Input_CenterId",
            [],
            { triggerFilter: () => this.filterCoresAndProjects() },
            undefined,
            false,
            false
        );
        InitializeFilterDropdown(
            "#Input_VirusFamilyId",
            [],
            { triggerFilter: () => this.filterChallengeViruses() },
            undefined,
            false,
            false
        );

        this.initPickers();
        this.$cores.on("changed.bs.select", () => this.syncHiddenFromSelects());
        this.$projects.on("changed.bs.select", () => this.syncHiddenFromSelects());

        const pmidsSlot = document.getElementById("pmids-slot");
        if (pmidsSlot) {
            this.pmids = new ListSelection(
                "add-am-pmids",                    
                "PublicationIdsRaw",              
                "Publications",                    // display name
                "Specify the PubMedId number (ex: 12345678).", // description
                false,                             // isRequired
                true                              
            );
            pmidsSlot.innerHTML = this.pmids.generateHtml();
            this.pmids.initialize([], []);       // no picklists needed

         
            const seed = (document.getElementById("Input_PublicationIdsRaw") as HTMLInputElement | null)?.value || "";
            if (seed) this.pmids.populateField(seed);
            else {
                // ENSURE- placeholder appears initially
                (this.pmids as any).updateListGallery();
            }
        }

        // Initial filter pass
        this.filterCoresAndProjects();
        this.filterChallengeViruses();

        this.wireLightValidation();
       
        this.wireAjaxCreateThenUpload();
        this.initProtocolWidget();
    }

    // ---- helpers

    private readOptions($jq: JQuery<HTMLSelectElement>): HTMLOptionElement[] {
        const el = $jq.get(0);
        return el && el.tagName === "SELECT"
            ? Array.from((el as HTMLSelectElement).options)
            : [];
    }

    private replaceOptions(
        $sel: JQuery<HTMLSelectElement>,
        full: HTMLOptionElement[],
        allowed: Set<number>
    ) {
        const el = $sel.get(0) as HTMLSelectElement | undefined;
        if (!el) return;

        const prev = new Set<string>(
            Array.from(el.selectedOptions || []).map((o) => o.value)
        );

        el.innerHTML = "";
        const frag = document.createDocumentFragment();
        for (const opt of full) {
            if (!allowed.size || allowed.has(Number(opt.value))) {
                const c = opt.cloneNode(true) as HTMLOptionElement;
                c.selected = prev.has(c.value);
                frag.appendChild(c);
            }
        }
        el.appendChild(frag);

        const anySel = $sel as any;
        if (typeof anySel.selectpicker === "function") {
            anySel.selectpicker("refresh");
        }

        // Re-apply paint to the *button*
        this.validateField(el);
    }

    // ---- filtering

    private filterCoresAndProjects() {
        const centerId = Number((this.$center.val() as string) || 0);
        const allowCores = new Set(this.maps.coreByCenter[centerId] ?? []);
        const allowProjects = new Set(this.maps.projectByCenter[centerId] ?? []);

        if (this.coreOpts.length) this.replaceOptions(this.$cores, this.coreOpts, allowCores);
        if (this.projectOpts.length) this.replaceOptions(this.$projects, this.projectOpts, allowProjects);
        this.syncHiddenFromSelects();
    }

    private filterChallengeViruses() {
        const famId = Number((this.$virusFamily.val() as string) || 0);
        const allow = new Set(this.maps.virusByFamily[famId] ?? []);
        if (this.challengeOpts.length) this.replaceOptions(this.$challenge, this.challengeOpts, allow);
    }

    // ---- pickers

    private initPickers(): void {
        const $all = $("select.selectpicker") as any;
        if (!$all.length) return;

        $all.selectpicker({
            container: "body",
            dropupAuto: false,
            size: 5,
            selectedTextFormat: "count",
            closeOnSelect: false,
            actionsBox: true,
            deselectAllText: "Clear",
            selectAllText: "All",
            countSelectedText: (n: number, t: number) => (n === t ? "All" : `${n} Selected`),
        });

        // When bootstrap-select rebuilds, re-paint the new button
        $all.on("loaded.bs.select refreshed.bs.select", (e: JQuery.TriggeredEvent) => {
            this.validateField(e.target as Element);
        });
    }

 

    // ---- validation

    private validateField(el: Element, force = false): boolean {
        const $el = $(el as HTMLElement);
        if ($el.closest(".bs-searchbox").length) return true;

        const isSelect = $el.is("select");
        const isInput = $el.is("input, textarea");
        if (!isSelect && !isInput) return true;

        const isMulti = isSelect && $el.is("[multiple]");
        const rangeMin = parseInt(String($el.attr("data-val-range-min") || "0"), 10);
        let required =
            $el.is('[data-val-required]') ||
            (isMulti && $el.is('[data-val-minlength]')) ||
            (!isMulti && rangeMin >= 1);

        // honor explicit opt-out
        if ($el.is('[data-optional="true"]')) required = false;

        const hasValue = isSelect
            ? (isMulti
                ? ((($el.val() as string[] | null) ?? []).length > 0)
                : (String($el.val() ?? "").trim() !== "" && String($el.val() ?? "") !== "0"))
            : (String(($el as any).val?.() ?? "").trim().length > 0);

        const ok = required ? hasValue : true;

        const touched = $el.attr("data-touched") === "true";
        const serverErr = $el.attr("data-server-error") === "true";
        const shouldPaint = force || this.hasTriedSubmit || touched || serverErr;

        if (isSelect) {
            const $picker = $el.closest(".bootstrap-select");
            const $btn = $picker.children("button.dropdown-toggle");

            if (shouldPaint) {
                
                $picker.toggleClass("is-invalid", !ok).toggleClass("is-valid", ok);
                
                $btn.removeClass("is-invalid is-valid");
              
                $el.attr("aria-invalid", (!ok).toString());
            } else {
                $picker.removeClass("is-invalid is-valid");
                $btn.removeClass("is-invalid is-valid");
                $el.removeAttr("aria-invalid");
            }
        } else {
            if (shouldPaint) {
                $el.toggleClass("is-invalid", !ok).toggleClass("is-valid", ok)
                    .attr("aria-invalid", (!ok).toString());
            } else {
                $el.removeClass("is-invalid is-valid").removeAttr("aria-invalid");
            }
        }

        return ok;
    }

    private wireLightValidation(): void {
        const $form = $("form.animal-models-form");
        if (!$form.length) return;

        $form.on("input blur", "input.form-control, textarea.form-control", (e) => {
            $(e.target).attr("data-touched", "true");
            this.validateField(e.target as Element);
        });

        $form.on("changed.bs.select", "select.selectpicker", (e) => {
            $(e.target).attr("data-touched", "true");
            this.validateField(e.target as Element);
        });

        this.applyServerErrors();

        $form.on("submit", (ev) => {
            this.hasTriedSubmit = true;
            let allOk = true;
            $form.find("input.form-control, textarea.form-control, select.selectpicker")
                .each((_i, el) => { if (!this.validateField(el, true)) allOk = false; });
            if (!allOk) { ev.preventDefault(); ev.stopImmediatePropagation(); }
        });
    }

    private applyServerErrors(): void {
        $("span.field-validation-error").each((_i, span) => {
            const forName = $(span).attr("data-valmsg-for");
            if (!forName) return;

            const $field = $(`[name="${forName}"]`);
            if (!$field.length) return;

            if ($field.is("select.selectpicker")) {
                const $picker = $field.closest(".bootstrap-select");
                $picker.addClass("is-invalid").removeClass("is-valid");  
                $picker.children("button.dropdown-toggle").removeClass("is-invalid is-valid");
                $field.attr("aria-invalid", "true");
            } else {
                $field.addClass("is-invalid").removeClass("is-valid");
            }
        });
    }


    // ---- Core/ Center
    
    private syncHiddenFromSelects(): void {
        const coreIds = (this.$cores.val() as string[] | null) ?? [];
        const projIds = (this.$projects.val() as string[] | null) ?? [];
        $("#Input_CoreIdsRaw").val(coreIds.join("|"));
        $("#Input_ProjectIdsRaw").val(projIds.join("|"));
    }



    // ---- Protocols
    private initProtocolWidget(): void {
        // id, propertyName, displayName, description, isRequired, rootFolderPath, isEdit, allowMultipleUploads
        this.protocolUpload = new FileUpload(
            "add-am-protocol-widget",
            "Protocol",
            "Protocol",
            "Please upload a <u>PDF</u> of the protocol (Max 1).",
            false,
            "am-uploads",
            false,     // new flow
            false      // single file
        );

        // point to THIS page’s handlers
        this.protocolUpload.getAttachmentsRoute = "/secure/new-am-form/new-am-form?handler=GetUploads";
        this.protocolUpload.addAttachmentsRoute = "/secure/new-am-form/new-am-form?handler=AddUploads";
        this.protocolUpload.removeAttachmentsRoute = "/secure/new-am-form/new-am-form?handler=RemoveUpload"; 

        // render into the slot
        const slot = document.getElementById("protocol-upload-slot");
        if (slot) {
            slot.innerHTML = this.protocolUpload.generateHtml();
            // new-mode: no existing items/docs
            this.protocolUpload.initialize([], []);
        }
    }

    // ----- Submit Interceptor
    private wireAjaxCreateThenUpload(): void {
        const $form = $("form.animal-models-form");
        if (!$form.length) return;

        $form.on("submit", async (ev) => {
            ev.preventDefault();
            ev.stopImmediatePropagation();

            this.hasTriedSubmit = true;
            let allOk = true;
            $form.find("input.form-control, textarea.form-control, select.selectpicker")
                .each((_i, el) => { if (!this.validateField(el as Element, true)) allOk = false; });
            if (!allOk) return;
            this.syncHiddenFromSelects();
            const pmidsVal = this.pmids ? this.pmids.getValue() : "";
            ($("#Input_PublicationIdsRaw") as any).val(pmidsVal);
            const fd = new FormData($form.get(0) as HTMLFormElement);
            fd.delete("Input.ProtocolFile"); // widget handles upload

            const anti = ($('input[name="__RequestVerificationToken"]').val() as string) || "";

            try {
                const res = await fetch("/secure/new-am-form/new-am-form?handler=CreateAjax", {
                    method: "POST",
                    body: fd,
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                        "RequestVerificationToken": anti
                    },
                    credentials: "same-origin"
                });

                const ct = res.headers.get("content-type") || "";
                if (!res.ok || !ct.includes("application/json")) {
                    throw new Error(`CreateAjax failed (${res.status}).`);
                }

                const json = await res.json();
                if (!json?.ok) {
                    
                    return;
                }

                const newId: number = json.id;
                await this.protocolUpload.uploadAttachments([{ Id: newId }]);

                window.location.assign("/secure/animal-models-hub/animal-models-hub");
            } catch (e) {
                console.error(e);
            }
        });
    }

}

